import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RoutePath } from '@shared/route-path.enum';
import { RegexPatterns } from '@shared/validators/regex-patterns.enum';
import { BehaviorSubject, iif } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ConfirmedValidator } from '../utils';

@Component({
	selector: 'sf-new-password',
	templateUrl: './new-password.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewPasswordComponent implements OnInit {
	public get policyAndTermsControl(): UntypedFormControl {
		return this.newPasswordForm.get('policyAndTerms') as UntypedFormControl;
	}

	public get generalTermsControl(): UntypedFormControl {
		return this.newPasswordForm.get('generalTerms') as UntypedFormControl;
	}
	public get newsletterControl(): UntypedFormControl {
		return this.newPasswordForm.get('newsletter') as UntypedFormControl;
	}

	public newPasswordForm: UntypedFormGroup;
	public isConfirmationVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public showNewsletterInfo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public urlToken: string;

	constructor(
		private fb: UntypedFormBuilder,
		private authService: AuthService,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.urlToken = this.activatedRoute.snapshot.params.token;
		this.newPasswordForm = this.fb.group(
			{
				password: ['', [Validators.required, Validators.pattern(RegexPatterns.PASSWORD)]],
				passwordRepeat: ['', [Validators.required]],
			},
			{ validators: ConfirmedValidator('password', 'passwordRepeat') }
		);
		if (this.activatedRoute.snapshot.routeConfig.path === RoutePath.SET_PASSWORD) {
			this.newPasswordForm.addControl('generalTerms', this.fb.control(false, Validators.requiredTrue));
			this.newPasswordForm.addControl('policyAndTerms', this.fb.control(false, Validators.requiredTrue));
			this.newPasswordForm.addControl('newsletter', this.fb.control(false));
		}
	}

	public onSave(): void {
		iif(
			() => this.activatedRoute.snapshot.routeConfig.path === RoutePath.NEW_PASSWORD,
			this.authService.resetPassword(this.newPasswordForm.getRawValue(), this.urlToken),
			this.authService.setNewPassword(this.newPasswordForm.getRawValue(), this.urlToken)
		)
			.pipe(
				tap(() => {
					this.isConfirmationVisible.next(true);
				})
			)
			.subscribe();
	}

	public showMore(event: Event): void {
		this.showNewsletterInfo.next(!this.showNewsletterInfo.value);
		event.stopPropagation();
		event.preventDefault();
	}
}
